import { render } from "./service.vue?vue&type=template&id=b3893bb4&scoped=true"
const script = {}

import "./service.vue?vue&type=style&index=0&id=b3893bb4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\97813\\Desktop\\汇智衣\\sd_hq_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3893bb4"]])

export default __exports__